import { render } from "./CanvasTour.vue?vue&type=template&id=3763ab02&ts=true"
import script from "./CanvasTour.vue?vue&type=script&lang=ts"
export * from "./CanvasTour.vue?vue&type=script&lang=ts"

import "./CanvasTour.vue?vue&type=style&index=0&id=3763ab02&lang=scss"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__